/** @jsxImportSource @emotion/react */
import { Tooltip } from '@mui/material';
import React from 'react';

import { CircleButton } from 'src/common/ui/components';
import RouterLink from 'src/components/general/routerLink';
import useMyDayToday from 'src/myDayToday/hooks/useMyDayToday';
import useRootStore from 'src/stores/useRootStore';

export const NavIconsMyDayToday = () => {
  const { auth } = useRootStore();

  const myDayTodayEnabled = useMyDayToday();
  if (!myDayTodayEnabled) {
    return null;
  }

  return (
    <Tooltip title="My Day Today" placement="bottom">
      {/** Tooltip requires a ref-able component as a child */}
      <span>
        <RouterLink routeName="myDayToday" params={{ id: auth.user?.id ?? '' }}>
          <CircleButton color="transparent-inverted" icon="home" />
        </RouterLink>
      </span>
    </Tooltip>
  );
};
